import React, { useState } from "react";
import styles from "./StatutTimeline.module.scss";
import tools from "../../../../../helpers/tools";
import useStore from "../../../../../context/useStore";

const LocalisationTimeline = ({
  localisationHistorique,
  onAddLocalisation,
  vehicleLocalisation,
  vehicleCatalogue,
}) => {
  const [state] = useStore();
  const [selectedLocalisation, setSelectedLocalisation] = useState("");
  const [showSelector, setShowSelector] = useState(false);

  const localisationsByCatalogue =
    state?.constant?.items?.FLOTTE?.LOCALISATIONS_VEHICULE || {};
  const localisationOptions = Array.isArray(localisationsByCatalogue)
    ? localisationsByCatalogue
    : localisationsByCatalogue[vehicleCatalogue] || [];

  const getLocalisationLabel = (localisationId) => {
    const ref = localisationOptions.find((l) => l.id === localisationId);
    return ref?.name || localisationId;
  };

  const handleAddLocalisation = () => {
    if (selectedLocalisation && onAddLocalisation) {
      onAddLocalisation({ localisation: selectedLocalisation });
      setSelectedLocalisation("");
      setShowSelector(false);
    }
  };

  const handleCancelAdd = () => {
    setSelectedLocalisation("");
    setShowSelector(false);
  };

  const sortedDateDescLocalisationHistorique = [
    ...(localisationHistorique || []),
  ].sort((a, b) => new Date(b.date) - new Date(a.date));

  return (
    <div className={styles.timeline}>
      <div
        className="d-flex justify-content-end align-items-center mb-2"
        style={{ gap: 8 }}
      >
        {vehicleLocalisation && (
          <span className="badge badge-info">
            {getLocalisationLabel(vehicleLocalisation)}
          </span>
        )}
      </div>

      {onAddLocalisation && (
        <div
          className={`${styles.timelineItem} ${styles.addStatutItem} ${
            (localisationHistorique || []).length === 0 ? styles.last : ""
          }`}
        >
          <div className={styles.timelineDate}></div>

          <div className={styles.timelineConnector}>
            <div
              className={`${styles.timelineDot} ${styles.addStatutDot} border`}
            >
              <i className="fas fa-plus"></i>
            </div>
            {(showSelector || (localisationHistorique || []).length > 0) && (
              <div className={styles.timelineLine}></div>
            )}
          </div>

          <div className={styles.timelineContent}>
            {!showSelector ? (
              <div className={styles.timelineHeader}>
                <button
                  className="btn btn-default mt-1 btn-sm mb-0 text-lowercase"
                  onClick={() => setShowSelector(true)}
                >
                  <i className="fas fa-plus mr-1"></i>
                  Modifier la localisation
                </button>
              </div>
            ) : (
              <div className={styles.addStatutForm}>
                <div className={styles.timelineHeader}>
                  <div className="">
                    <select
                      className="form-control rounded-pill"
                      value={selectedLocalisation}
                      onChange={(e) => setSelectedLocalisation(e.target.value)}
                    >
                      <option value="">Sélectionner une localisation...</option>
                      {localisationOptions.map((loc) => (
                        <option key={loc.id} value={loc.id}>
                          {loc.name}
                        </option>
                      ))}
                    </select>
                    <div className="d-flex" style={{ gap: "0.5rem" }}>
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={handleAddLocalisation}
                        disabled={!selectedLocalisation}
                      >
                        <i className="fas fa-check mr-1"></i>
                        Valider
                      </button>
                      <button
                        className="btn btn-default btn-sm shadow-none border-0"
                        onClick={handleCancelAdd}
                      >
                        <i className="fas fa-times mr-1"></i>
                        Annuler
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {sortedDateDescLocalisationHistorique.map((item, index) => (
        <div
          key={index}
          className={`${styles.timelineItem} ${
            index === sortedDateDescLocalisationHistorique.length - 1
              ? styles.last
              : ""
          }`}
        >
          <div className={styles.timelineDate}>
            <small className="text-muted">{tools.formatDate(item.date)}</small>
          </div>

          <div className={styles.timelineConnector}>
            <div
              className={`${styles.timelineDot} border`}
              style={{ backgroundColor: "#17a2b8" }}
            >
              <i className="fas fa-map-marker-alt"></i>
            </div>
            {index < sortedDateDescLocalisationHistorique.length - 1 && (
              <div className={styles.timelineLine}></div>
            )}
          </div>

          <div className={styles.timelineContent}>
            <div className={styles.timelineHeader}>
              <span className="badge badge-info">
                {getLocalisationLabel(item.localisation)}
              </span>
            </div>

            {item.utilisateur && (
              <div className={styles.timelineUser}>
                <i className="fas fa-user text-muted mr-1"></i>
                <span className="text-muted">{item.utilisateur}</span>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default LocalisationTimeline;
